

export default function getItemUnit(itemCategory,jjxx,convertUnit){
  if(convertUnit===undefined){
    convertUnit = true;
  }

  let option_crxs = jjxx.option_crxs;
  let yqjg = parseFloat(jjxx.option_yqjg);
  let output = "unit-10k-per-mu";

  if(yqjg>=1000 && convertUnit===true){
    output = "unit-100m-per-mu";
  }else{
    output = "unit-10k-per-mu";
  }

  if(itemCategory==="jzwz"){
    if(option_crxs==="zz"){
      if(yqjg>=1000 && convertUnit===true){
        output = "unit-100m-per-year";
      }else{
        output = "unit-10k-per-year";
      }
    }else{
      if(yqjg>=1000 && convertUnit===true){
        output = "unit-100m-per-squre-meter";
      }else{
        output = "unit-10k-per-squre-meter";
      }
    }
  }

  return app.translator.trans("ziven-u2di.lib."+output);
}